import React from 'react'

const EducationalTechnology = () => {
    return (
        <section className='p-4 md:p-24'>

            <div className='flex flex-col gap-5'>


                <h1 className='text-xl md:text-3xl'>Educational Technology</h1>

                <p>Currently the community of the school communicates with the use of Google applications.  Wi-Fi has been implemented in both campuses and multi-media systems are available in every classroom. The school also has a one laptop per child programme, for all students from PYP 4 to DP 2.In addition to this,  the school provides laptops in classes from Nursery till PYP-3, to facilitate inquiry.</p>

                <p>KOHA, the library management system, aids the cataloguing and circulation of resources in both campuses.</p>

                <p>The International School’s curriculum is accessible to all students, parents and faculty members through the online ManageBac service. Students are able to view and upload all assignments onto this forum, where tasks may be screened by plagiarism detection software TURNITIN.</p>


            </div>


        </section>
    )
}

export default EducationalTechnology